import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Icons, IconType } from '../../../../constants/icons';
import { getTextToGameVideoPreview } from '../../../../constants/images';
import { getCreateGameVideo } from '../../../../constants/videos';
import { Profile } from '../../../../models/UserStore';
import {
  TextButton,
  TextButtonFontSize,
  TextButtonSize,
  TextButtonVariant,
  VideoPlayer,
} from '../../../Molecules';
import {
  AssetDisplayBar,
  CurrencyAmount,
} from '../../../Molecules/AssetDisplayBar';

import './CreateMainTemplate.css';

type CreateMainTemplateProps = {
  profile: Profile | null | undefined;
  currencies: CurrencyAmount[];
  onCreateOwn: () => void;
  onProvideContent: () => void;
};

export const CreateMainTemplate = memo(
  ({
    profile,
    currencies,
    onCreateOwn,
    onProvideContent,
  }: CreateMainTemplateProps) => {
    const { t, i18n } = useTranslation();

    return (
      <div className="create-main">
        <div className="centered-container">
          <div className="logo-container">
            <img
              className="logo-icon"
              src={Icons[IconType.CreateGameContent]}
            />
          </div>
          <div className="smart-video">
            <VideoPlayer
              url={getCreateGameVideo(i18n.language)}
              thumbnailUrl={getTextToGameVideoPreview(i18n.language)}
              playIcon={<></>}
              playing={true}
            />
          </div>

          <p className="text">
            {t('Input the content you want to convert to AI Memory Games.')}
          </p>
          {profile != null && (
            <div className="container-box">
              <AssetDisplayBar profile={profile} currencies={currencies} />
            </div>
          )}
          <div className="button-container-box">
            <TextButton
              text={t('Create On Your Own')}
              size={TextButtonSize.Medium}
              fontSize={TextButtonFontSize.Small}
              variant={TextButtonVariant.Green}
              onClick={onCreateOwn}
            />
          </div>
          <p className="text">
            {t(
              'Provide your content, then WEA’s Content Specialist Team will convert them to AI Memory Games in 7 working days.',
            )}
          </p>
          <div className="button-container-box">
            <TextButton
              text={t('Provide Content to WEA')}
              size={TextButtonSize.Medium}
              fontSize={TextButtonFontSize.Small}
              variant={TextButtonVariant.Green}
              onClick={onProvideContent}
            />
          </div>
        </div>
      </div>
    );
  },
);
